var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      staticClass: "app-toast promptValue",
      class: [
        _vm.type == "notice" ? "notice" : "",
        _vm.type == "fail" || _vm.type == "fail2" ? "error" : "",
        _vm.type == "loginSuccess" || _vm.type == "success" ? "success" : "",
        _vm.type == "fail2" ? "app-toast-fail2" : ""
      ]
    },
    [
      _c("div", { staticClass: "status-info" }, [
        _c("div", { staticClass: "status-info-box" }, [
          _vm.type === "success" || _vm.type == "loginSuccess"
            ? _c("div", {
                staticClass: "icon-util info-success info-success-position"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "fail"
            ? _c("div", {
                staticClass: "icon-util info-fail info-success-position"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "fail2"
            ? _c("div", {
                staticClass: "icon-util info-fail info-success-position"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "note"
            ? _c("div", {
                staticClass: "icon-util info-note info-success-position"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "notice"
            ? _c("div", {
                staticClass: "infonotebox-closer",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.isShow = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { ref: "exceptionText" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } }),
            _vm._v(" "),
            _vm.multCloudShow && _vm.type != "notice"
              ? _c(
                  "a",
                  {
                    staticClass: "learn-more-exception",
                    style: "font-size: 14px;",
                    attrs: {
                      target: "_blank",
                      href: "https://www.multcloud.com/"
                    }
                  },
                  [_vm._v("multcloud.com")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.toTaskShow && _vm.type != "notice"
              ? _c(
                  "span",
                  {
                    staticClass: "alink",
                    on: {
                      click: function($event) {
                        return _vm.jumpToLogin("task")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.vm.$t(
                          "language.sharesPage.createTransferSuccessAfter"
                        )
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.toSavedSharesShow && _vm.type != "notice"
              ? _c(
                  "span",
                  {
                    staticClass: "alink",
                    on: {
                      click: function($event) {
                        return _vm.jumpToLogin("savedShare")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.vm.$t("language.sharesPage.saveLinkSuccessAfter")
                      )
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.learnMoreShow && _vm.type != "notice" && _vm.type != "note"
            ? _c(
                "a",
                {
                  staticClass: "learn-more-exception",
                  attrs: {
                    target: "_blank",
                    href: "https://www.multcloud.com/help/solutions.html"
                  }
                },
                [_vm._v(_vm._s(_vm.vm.$t("language.meassage.leanMore")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type != "loginSuccess"
            ? _c("span", {
                staticClass: "info-close",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.isShow = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "loginSuccess"
            ? _c(
                "span",
                {
                  staticClass: "operate",
                  on: {
                    click: function($event) {
                      return _vm.skip()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.vm.$t("language.meassage.skip")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "loginSuccess"
            ? _c(
                "span",
                {
                  staticClass: "operate",
                  staticStyle: { left: "-5px" },
                  on: {
                    click: function($event) {
                      return _vm.active()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.vm.$t("language.meassage.activate")))]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a4f4fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4f4fc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/messages/message.vue
// module id = null
// module chunks = 